import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

const CUSTOMER_NUMBER_LENGTH = 8;
const PADDED_NUMBER_INSTITUTES = new Set(['0100', '0101', '0110', '0109']);

export const customerIdNormalizerGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const entity = route.params['entity'] as string | undefined;
  const customerId = route.params['customerId'] as string | undefined;

  if (!entity || !customerId) return true;
  if (!PADDED_NUMBER_INSTITUTES.has(entity)) return true;
  if (!/^\d+$/.test(customerId)) return true;

  const normalizedCustomerId = customerId
    .replace(/^0+/, '')
    .padStart(CUSTOMER_NUMBER_LENGTH, '0');

  if (normalizedCustomerId === customerId) return true;

  const correctedUrl = state.url.replace(
    `/customer/${customerId}`,
    `/customer/${normalizedCustomerId}`
  );
  return router.parseUrl(correctedUrl);
};
